import { useAuth } from 'react-oidc-context'

const useAuthHook = () => {
  const { isAuthenticated, user, isLoading, signinRedirect } = useAuth()

  return {
    isAuthenticated,
    user,
    signinRedirect,
    isLoading,
  }
}

export default useAuthHook
